import { useI18n } from 'vue-i18n'

/**
 * Composable for i18n translation with fallback, similar to GlobalMixins.js useI18
 * @returns { useI18 } - function(key, params, defaultValue)
 */
export function useI18() {
  const { t, te } = useI18n()

  function useI18(key: string, params: Record<string, unknown> = {}, defaultValue = ''): string {
    if (!te(key)) return defaultValue
    return t(key, params) as string
  }

  return { useI18 }
}
